import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import messages from "../../../../assets/locale/messages";
import Modal from "../../../../components/Modal";
import { WarningBlueBgIcon } from "../../../../utils/Icons";

const WarningModal = ({ open, onClose, onConfirm }) => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    shared,
    roles: {
      addRole: { warningModal }
    }
  } = messages[lang];

  return (
    <Modal
      open={open}
      icon={<WarningBlueBgIcon />}
      title={warningModal.title}
      content={warningModal.content}
      confirmBtnTxt={warningModal.proceed}
      cancelBtnTxt={shared.cancel}
      handleClose={onClose}
      handleCancel={onClose}
      handleConfirm={onConfirm}
    />
  );
};

export default WarningModal;

WarningModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
